exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Messages_menu_SYYD {\n  margin-bottom: 20px;\n}\n\n.Messages_actionContainer_3x8x {\n  margin-top: 20px;\n  padding-top: 20px;\n\n  text-align: center;\n\n  border-top: 1px solid #e6e6e6;\n}\n\n.Messages_emptyMessage_bYc1 {\n  text-align: center;\n\n  color: #787878;\n}\n\n.Messages_errorStatus_3UkC {\n  max-width: 100%;\n\n  text-align: left;\n}\n\n.Messages_continueWorkingButton_rYwt {\n  margin-left: 20px;\n}\n", ""]);

// exports
exports.locals = {
	"menu": "Messages_menu_SYYD",
	"actionContainer": "Messages_actionContainer_3x8x",
	"emptyMessage": "Messages_emptyMessage_bYc1",
	"errorStatus": "Messages_errorStatus_3UkC",
	"continueWorkingButton": "Messages_continueWorkingButton_rYwt"
};